import { Reveal } from "../landing/Reveal";

const ACTIVITY = [
  { name: "Priya", text: "sold 120 meals this week", emoji: "🍔", grad: "from-[#F97316] to-[#22C55E]", time: "2m ago" },
  { name: "Rahul", text: "got placed at Microsoft", emoji: "💼", grad: "from-[#7C3AED] to-[#06B6D4]", time: "9m ago" },
  { name: "Akash", text: "earned ₹12,000 from referrals", emoji: "💰", grad: "from-[#06B6D4] to-[#7C3AED]", time: "21m ago" },
  { name: "Anjali", text: "completed AI Certification", emoji: "🎓", grad: "from-[#22C55E] to-[#F97316]", time: "34m ago" },
];

const TRENDING = [
  { emoji: "🔥", label: "Trending", count: "2.4K now" },
  { emoji: "🍔", label: "Meals", count: "380 live" },
  { emoji: "💼", label: "Internships", count: "142 open" },
  { emoji: "✈️", label: "Trips", count: "56 deals" },
  { emoji: "📚", label: "Courses", count: "890+" },
  { emoji: "🛍", label: "Flash Deals", count: "ends 2h" },
];

export const SocialFeed = () => (
  <section id="feed" data-testid="social-feed" className="relative py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">
          Live on FUNZ
        </p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          Your campus is moving right now.
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ACTIVITY.map((a, i) => (
          <Reveal key={a.name} delay={0.07 * i}>
            <div
              data-testid={`feed-card-${a.name.toLowerCase()}`}
              className="group rounded-3xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#7C3AED]/50"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br text-xl ${a.grad}`}>
                  {a.emoji}
                </span>
                <span className="font-jbmono text-[10px] text-slate-500">{a.time}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-slate-300">
                <span className="font-bold text-white">{a.name}</span> {a.text}
              </p>
              <div className="mt-4 flex items-center gap-4 font-jbmono text-[11px] text-slate-500">
                <span className="transition-colors group-hover:text-[#F97316]">❤️ 248</span>
                <span>💬 36</span>
                <span>↗ Share</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div
          data-testid="trending-scroll"
          className="no-scrollbar -mx-4 mt-10 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2"
        >
          {TRENDING.map((t) => (
            <button
              key={t.label}
              data-testid={`trending-${t.label.toLowerCase().replace(" ", "-")}`}
              className="flex shrink-0 snap-start items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4 backdrop-blur-xl transition-colors hover:border-[#06B6D4]/50"
            >
              <span className="text-2xl">{t.emoji}</span>
              <span className="text-left">
                <span className="block text-sm font-bold text-white">{t.label}</span>
                <span className="block font-jbmono text-[10px] text-[#06B6D4]">{t.count}</span>
              </span>
            </button>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
